import React from 'react'
import { Number, Grid } from '../Blocks';
import { updateNumber, resetNumbers, selectNumberColor } from '../../utilities';

const NumberPad = () => {
    return (
        <Grid cols="repeat(3, 50px)" rows="repeat(4, 50px)" gap="12px" width="fit-content">

            <Number number="1" handleClick={() => updateNumber("1")} />
            <Number number="2" handleClick={() => updateNumber("2")} />
            <Number number="3" handleClick={() => updateNumber("3")} />
            <Number number="4" handleClick={() => updateNumber("4")} />
            <Number number="5" handleClick={() => updateNumber("5")} />
            <Number number="6" handleClick={() => updateNumber("6")} />
            <Number number="7" handleClick={() => updateNumber("7")} />
            <Number number="8" handleClick={() => updateNumber("8")} />
            <Number number="9" handleClick={() => updateNumber("9")} />
            <Number number="↻" bg="#ddaaaa" handleClick={() => resetNumbers()} />
            <Number number="0" handleClick={() => updateNumber("0")} />
            <Number number="✔" bg="#aaccaa" handleClick={() => selectNumberColor()} />

        </Grid>
    )
}

export default NumberPad